import React, { useContext, useState } from "react";
import { AddToolTip, FormControlSearch } from "../../../components";
import { default as uuid } from "uuid";
import { InputGroup } from "react-bootstrap";
import PassthroughUnmappedField from "./PassthroughUnmappedField";
import { Droppable } from "react-beautiful-dnd";
import { get, isEmpty } from "lodash";
import PassthroughTargetDroppedContainer from "./PassthroughTargetDroppedContainer";
import { useEffect } from "react";
import FieldSetupSlider from "../MapAndTransformOutput/FieldSetupSlider";
import { useRouterParams } from "../../../abstracts";
import {
  passthroughStringToFunctionConverter,
  removePassthroughFieldTrans,
} from "../../../utils";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
const PassthroughTargetContainer = (props) => {
  const {
    mappingData,
    list,
    setList,
    passthroughFileName,
    sorceData,
    isRequiredPassthrough,
    searchList,
    setSearchList,
  } = props;
  const { flow, profileId, mapType } = useRouterParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [showSlideOut, setShowSlideOut] = useState(false);
  const [fieldIndex, setFieldIndex] = useState(0);
  const [fieldOrder, setFieldOrder] = useState(0);
  const [fieldArrayName, setFieldArrayName] = useState(null);
  const [masterSourceDate, setMasterSourceDate] = useState(null);
  const [trigger, setTrigger] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  useEffect(() => {
    {
      if (!isSearch) {
        setSearchList(list);
      }
    }
  }, [list, trigger]);
  useEffect(() => {
    setMasterSourceDate(
      sorceData?.map((item) => ({
        id: uuid.v4(),
        order: item.order,
        propertyName: item.propertyName,
        fieldName: item.fieldName,
        type: item.type,
        datum: item.datum,
      }))
    );
  }, [sorceData]);
  let targetLength = searchList?.filter((_) => _.fieldName != "/FIELD NAME");
  const onDeleteMapping = (order) => {
    const getSeatchList = searchList.find((_) => _.order == order);
    const getTargetList = list.find((_) => _.order == order);
    if (getSeatchList.isNewField) {
      setSearchList(searchList.filter((obj) => obj.order !== order));
    }
    if (getTargetList.isNewField) {
      setList(list.filter((obj) => obj.order !== order));
    }
    if (
      isNullOrUndefined(getSeatchList.isNewField) ||
      getSeatchList.isNewField
    ) {
      setSearchList(
        searchList?.map((item, ind) => {
          if (item.order == order) {
            return {
              ...item,
              path: null,
              isConfiguration: false,
              value: null,
            };
          } else {
            return { ...item };
          }
        })
      );
    }
    if (
      isNullOrUndefined(getTargetList.isNewField) ||
      !getTargetList.isNewField
    ) {
      setList(
        list?.map((item, ind) => {
          if (item.order == order) {
            return {
              ...item,
              path: null,
              isConfiguration: false,
              value: null,
            };
          } else {
            return { ...item };
          }
        })
      );
    }
  };
  const handleChange = (e) => {
    setIsSearch(true);
    setSearchTerm(e.target.value);
    setSearchList(
      list.filter((c) =>
        c?.fieldName
          ?.substring(1)
          .toLowerCase()
          .includes(e.target.value?.toLowerCase())
      )
    );
  };
  return (
    <div className="targerContainer">
      <div className="ft-16 fw-600 mb-1">Target</div>
      <div className="ft-14 fw-600">{passthroughFileName}</div>
      <div className="NumberOfFieldsText w-100">
        {targetLength?.length} Fields
      </div>

      <div className="SearchBarContainer">
        <div className="mapper-source-search-text">
          <InputGroup className="cross-override-close">
            <InputGroup.Prepend>
              <div className="passthrough-search-icon-postion ml-2">
                <i class="fal fa-search" aria-hidden="true"></i>
              </div>
            </InputGroup.Prepend>
            <FormControlSearch
              size="sm"
              id="source-search-box"
              screen={"mapper-passthrough"}
              type="search"
              className="plan-search-box pl-5"
              placeholder="Search"
              onChange={handleChange}
              autoComplete="off"
              onKeyPress={(e) => {
                e.key === "Enter" && handleChange(e);
              }}
            />
          </InputGroup>
        </div>
      </div>
      <div className="targetfields">
        {searchList?.map((item, index) => {
          return (
            <Droppable droppableId={item.order}>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="mw-100"
                >
                  <div className={"mt-1 ft-12 fw-500 w-50"}>
                    {item?.isNewField ? (
                      <AddToolTip
                        name={passthroughStringToFunctionConverter(
                          removePassthroughFieldTrans(item.fieldName),
                          masterSourceDate,
                          0
                        )?.toString()}
                      />
                    ) : (
                      <div className="d-flex">
                        <AddToolTip name={item.fieldName?.substring(1)} />
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "400",
                            display: "flex",
                            alignSelf: "flex-end",
                            color: "red",
                            marginLeft: "3px",
                          }}
                        >
                          *
                        </div>
                      </div>
                    )}
                  </div>
                  {sorceData?.find(
                    (x) =>
                      x.fieldName?.replaceAll("/", "") ==
                      item.path?.replaceAll("/", "")
                  ) || !isEmpty(item.value) ? (
                    <PassthroughTargetDroppedContainer
                      setShowSlideOut={setShowSlideOut}
                      setFieldOrder={setFieldOrder}
                      index={index}
                      setFieldIndex={setFieldIndex}
                      data={item}
                      onDeleteMapping={onDeleteMapping}
                      masterSourceDate={masterSourceDate}
                      mappedObject={item?.fieldName}
                    />
                  ) : (
                    <PassthroughUnmappedField
                      isRequiredPassthrough={isRequiredPassthrough}
                      setShowSlideOut={setShowSlideOut}
                      index={index}
                      setFieldIndex={setFieldIndex}
                      setFieldOrder={setFieldOrder}
                      data={item}
                    />
                  )}
                  <span
                    className="ml-1"
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      width: "60%",
                      display: "flex",
                      alignSelf: "flex-end",
                      color: "red",
                      marginTop: "-10px",
                    }}
                  >
                    {item?.isConfiguration == false &&
                      isRequiredPassthrough &&
                      "Required"}
                  </span>
                </div>
              )}
            </Droppable>
          );
        })}
      </div>
      {!isEmpty(searchList) && (
        <FieldSetupSlider
          fieldOrder={fieldOrder}
          list={list}
          setList={setList}
          setShowSlideOut={setShowSlideOut}
          mappedData={searchList}
          setMappedData={setSearchList}
          fieldIndex={fieldIndex}
          setFieldIndex={setFieldIndex}
          index={fieldIndex}
          showSlideOut={showSlideOut}
          hasHeader={searchList[fieldIndex]?.isNewField}
          fieldArrayName={fieldArrayName}
          masterSourceDate={masterSourceDate}
          setFieldArrayName={setFieldArrayName}
          profileId={profileId}
          dataModel={4}
          mapType={mapType}
          sourceHeaderName={
            !isEmpty(searchList) &&
            searchList[fieldIndex]?.fieldName?.substring(1)
          }
        />
      )}
    </div>
  );
};

export default PassthroughTargetContainer;
